import React, { useEffect, useState } from 'react';
import Header from '../../Layout/Header';
import toast from 'react-hot-toast';
import { SERVER_URL } from '../../../config';
import axios from 'axios';
import { PDFDocument } from 'pdf-lib';

export default function Test() {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [healthData, setHealthData] = useState([]);

  const handleFileChange = async (e) => {
    const selected = e.target.files[0];

    if (selected) {
      const fileType = selected.type;

      if (
        fileType.startsWith('image/') ||
        fileType === 'application/pdf' ||
        fileType === 'application/msword' ||
        fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
        setFile(selected);
      } else {
        toast.error("Please upload a valid file (Image, PDF, or DOC).");
      }
    }
  };

  useEffect(() => {
    const processFile = async () => {
      if (!file) return;

      if (file.type === 'application/pdf') {
        try {
          const base64 = await extractPagesFromPDF(file, 6, 12);
          setFileName(base64);
        } catch (error) {
          console.error("Error processing PDF:", error);
        }
      } else {
        try {
          const base64 = await getBase64(file);
          setFileName(base64);
        } catch (error) {
          console.error("Error converting file:", error);
        }
      }
    };

    processFile();
  }, [file]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);

      reader.readAsDataURL(file);
    });
  };

  const extractPagesFromPDF = async (file, startPage, endPage) => {
    const arrayBuffer = await file.arrayBuffer();
    const originalPdf = await PDFDocument.load(arrayBuffer);
    const totalPages = originalPdf.getPageCount();

    if (startPage < 1 || endPage > totalPages || startPage > endPage) {
      throw new Error("Invalid page range");
    }

    const newPdf = await PDFDocument.create();
    const pagesToCopy = await newPdf.copyPages(originalPdf, 
      Array.from({ length: endPage - startPage + 1 }, (_, i) => i + startPage - 1)
    );

    pagesToCopy.forEach((page) => {
      newPdf.addPage(page);
    });

    const pdfBytes = await newPdf.save();

    return new Promise((resolve, reject) => {
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result); // data:application/pdf;base64,...
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;
    const data = {
      pdfFile: fileName
    };
    console.log(fileName);
    await axios.post(`${SERVER_URL}/pyapi/pdfParse`, data).then((res) => {
      console.log(res, 'response');
      setHealthData(res.data.parsedData);
    });
  };

console.log(healthData,'health data')
  return (
    <div className='lg:h-screen flex flex-col items-center justify-center bg-cover pt-10 lg:pt-0 overflow-hidden' style={{ backgroundImage: 'url("/assets/bg/Authbg.svg")' }}>
      {Object.keys(healthData).length == 0 && (
      <div className='w-[90%] flex flex-col-reverse lg:flex-row items-center gap-10'>
        <div className='w-[100%] lg:w-[50%] text-white relative'>
          <div className='bg-white/5 lg:w-[90%] 2xl:w-[80%] 2xl:mx-auto p-7 lg:px-10 py-10 lg:py-20 2xl:py-24 brand-fade-2'>
            <div className='w-[100%] md:w-[90%] mx-auto mt-5'>
              <label className='font-semibold text-lg'>Upload PDF</label>
              <input
                type="file"
                onChange={handleFileChange}
                required
                className='w-[100%] mt-1 border rounded outline-none py-2 px-3'
              />
            </div>

            <div className='flex justify-center mt-5'>
              <button onClick={handleSubmit} className='border rounded-full flex items-center p-4 gap-2 py-[2px] pl-5 pr-[2px] cursor-pointer'>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      )}
      {healthData && Object.keys(healthData).length > 0 && (
  <div className="table-container overflow-auto max-h-[80vh]">
    <table className="table-auto w-full mt-10 text-white border border-gray-600">
      <thead>
        <tr className="bg-gray-700 text-white">
          <th className="px-4 py-2 border border-gray-600">Category</th>
          <th className="px-4 py-2 border border-gray-600">Trait</th>
          <th className="px-4 py-2 border border-gray-600">Metrics</th>
          <th className="px-4 py-2 border border-gray-600">Risk/Level</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(healthData).map((category) => (
          <React.Fragment key={category}>
            {/* Category row */}
            <tr className="bg-gray-800">
              <td className="px-4 py-2 font-bold border border-gray-600" colSpan="4">
                {category}
              </td>
            </tr>

            {/* Trait rows */}
            {healthData[category].map((trait, index) => (
              <tr key={index} className="bg-gray-900">
                <td className="px-4 py-2 border border-gray-600"></td>
                <td className="px-4 py-2 border border-gray-600">{trait.Trait}</td>
                <td className="px-4 py-2 border border-gray-600">{trait.Metrics}</td>
                <td className="px-4 py-2 border border-gray-600">{trait["Risk/Level"]}</td>
              </tr>
            ))}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  </div>
)}


<style>{`
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    color: #fff;
    overflow: auto;  /* Enable scrolling if the table overflows */
  }
  th, td {
    border: 1px solid #ddd;
    padding: 10px;  /* Increase padding to make it more readable */
    text-align: left;
    color: #fff !important;
  }
  th {
    color: #000; /* Change to black for better contrast */
  }
  .category-title {
    background-color: #e0e0e0;
    font-weight: bold;
    padding: 10px 0;
    color: #000; /* Change to black for better contrast */
  }
  /* Ensure table is visible and has enough space */
  .table-container {
    overflow: auto;
    max-height: 500px; /* Set a max-height to enable scrolling */
  }
`}</style>
    </div>
  );
}
